import { render } from "./AdminExamBadgeManagement.vue?vue&type=template&id=9b3de752&scoped=true"
import script from "./AdminExamBadgeManagement.vue?vue&type=script&lang=js"
export * from "./AdminExamBadgeManagement.vue?vue&type=script&lang=js"

import "./AdminExamBadgeManagement.vue?vue&type=style&index=0&id=9b3de752&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b3de752"]])

export default __exports__